
import "@babel/polyfill"


import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'


import "@/assets/fonts/iconfont.css"  //iconfont图标
import "@/assets/fonts2/iconfont.css"  //iconfont图标
import "@/assets/css/common.css";
// import "@/assets/css/animation.css";
// import "@/assets/css/van_reset.scss";  //样式文件
import "@/assets/sass/index.scss"
// import "@/assets/swiper/swiper.min.css";



// 引入viewer样式
import "../node_modules/viewerjs/dist/viewer.min.css"

// 引入element ui
import "./element-ui";

// 引入复制方法
import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)

import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'vue-awesome-swiper/node_modules/swiper/dist/css/swiper.css'
Vue.use(VueAwesomeSwiper, /* { 全局组件的默认选项 } */)

import api from './api';
Vue.prototype.$api = api; // 将api挂载到vue的原型上

import './filter/index'  // 引入自定义过滤器
import utils from './utils';  //引入自定义小工具方法
Vue.prototype.$utils = utils;

import waterfall from 'vue-waterfall2'
Vue.use(waterfall)

import dict from '@/components/Dict'
Vue.use(dict);


import * as echarts from 'echarts'
Vue.prototype.$echarts = echarts;

// 自定义指令，设置网页标题，v-title
Vue.directive('title', {
  inserted: function (el, binding) {
    utils.setMetaTitle(binding.value)
  }
})

const wtMarker = '/watermark,t_70,image_aW1nL2xvZ28ucG5n'
const wtMarker10 = '/watermark,t_70,image_aW1nL2xvZ28ucG5nP3gtb3NzLXByb2Nlc3M9aW1hZ2UvcmVzaXplLFBfMTA'
const wtMarker20 = '/watermark,t_70,image_aW1nL2xvZ28ucG5nP3gtb3NzLXByb2Nlc3M9aW1hZ2UvcmVzaXplLFBfMjA'
const wtMarker30 = '/watermark,t_70,image_aW1nL2xvZ28ucG5nP3gtb3NzLXByb2Nlc3M9aW1hZ2UvcmVzaXplLFBfMzA'
Vue.prototype.imgBlur = '/blur,r_5,s_5'
Vue.prototype.wtMarker = wtMarker

Vue.prototype.setImage = (base, path, string, hideWt, wtExt) => {
  let imgUrl = ''
  let wt = !hideWt ? wtMarker : ''
  if (wtExt && wt) {
    wt += wtExt
    if (wtExt == 10) {
      wt = wtMarker10
    } else if (wtExt == 20) {
      wt = wtMarker20
    } else if (wtExt == 30) {
      wt = wtMarker30
    }
  }
  if (path) {
    if (string) {
      imgUrl = base + path + string + ',limit_0' + wt + '/format,webp';
    } else {
      imgUrl = base + path + '?x-oss-process=image' + wt + '/format,webp';
    }
  }
  return imgUrl
}

Vue.prototype.setContent = (content) => {
  if (content) {
    let imagePaths = content.toLowerCase().match(/(https?:\/\/[^\s]+?\.(jpg|jpeg|png|gif))/g);

    if (imagePaths && imagePaths.length) {
      imagePaths.forEach(v => {
        content = content.replace(v, Vue.prototype.setImage('', v, '', false, 10))
      })
    }
  }
  return content
}

Vue.prototype.imgError = (row, fields) => {
  row.cover_img = row.thumbs
  if (fields) {
    if (typeof(fields) == 'string') {
      row[fields] = row.thumbs
    } else {
      fields.forEach(v => {
        row[v] = row.thumbs
      })
    }
  }
}

Vue.prototype.checkImage = async (base, path, string, noDefault) => {
  let defaultImg = noDefault ? '' : require('./assets/images/defaultImg.png');
  let imgUrl = defaultImg
  if (path) {
    if (string) {
      imgUrl = base + path + string + ',limit_0' + wtMarker + '/format,webp';
    } else {
      imgUrl = base + path
    }
    if (imgUrl) {
      let exist = await imgUrlExist(imgUrl);
      if (!exist) {
        imgUrl = base + path
        exist = await imgUrlExist(imgUrl);
        if (!exist) {
          imgUrl = defaultImg
        }
      }
    }
  }
  return imgUrl
}

let imgUrlExist = function (url) {
  return new Promise((resolve) => {
    let img = new Image();
    img.src = url;
    img.onload = function () {
      resolve(true);
      img = null;
    }
    img.onerror = function () {
      resolve(false);
      img = null;
    }
  })
}

/**
 * 防抖
 */
Vue.prototype._debounce = function (func, wait, immediate) {
  let timeout;
  return function () {
    let context = this;
    let args = arguments;
    clearTimeout(timeout);

    if (immediate) {
      let calling = !timeout;
      timeout = setTimeout(function () {
        timeout = null;
      }, wait);
      if (calling) {
        return func.apply(context, args);
      }
    } else {
      timeout = setTimeout(function () {
        func.apply(context, args);
      }, wait);
    }
  }
}

router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title
  }
  if (typeof _hmt !== "undefined") {
    if (to.path) {
      _hmt.push(["_trackPageview", to.fullPath]);
    }
  }
  next()
})



Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
